import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ParcellaFormRipartizione } from 'src/app/common/form/parcelle/parcella-form-ripartizione';
import { SezioneParcelleGiudizialiResponse } from 'src/app/common/models/dto/sezione-parcelle-giudiziali-response';
import {
  SezioneParcelleStragiudizialiResponse
} from 'src/app/common/models/dto/sezione-parcelle-stragiudiziali-response';
import { ParcellaGiudiziale } from 'src/app/common/models/parcella-giudiziale';
import { ParcellaSoggetto } from 'src/app/common/models/parcella-soggetto';
import { ParcellaStragiudiziale } from 'src/app/common/models/parcella-stragiudiziale';
import { SezioneParcelleGiudiziali } from 'src/app/common/models/sezioni/sezione-parcelle-giudiziali';
import { SezioneParcelleStragiudiziali } from 'src/app/common/models/sezioni/sezione-parcelle-stragiudiziali';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { OperationsService } from 'src/app/core/services/operations.service';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { ParcellaStragiudizialeAdapter } from '../parcelle-stragiudiziali-edit/parcella-stragiudiziale-adapter';


@Component({
    selector: 'div [parcella-form-ripartizione]',
  templateUrl: '../../../form/parcelle/parcella-form-ripartizione.html'
})

export class ParcelleRipartizioneComponent extends ParcellaFormRipartizione implements OnInit {
  sezione: SezioneParcelleGiudiziali | SezioneParcelleStragiudiziali;
  ripartizione: ParcellaSoggetto;
  urlUpdate: string;
  urlReadSezioneControparti: string;
  urlReadSezioneEconomica: string;
  urlUpdatePetitumEconomico: string;

  @Output() onReturn: EventEmitter<SezioneParcelleGiudiziali | SezioneParcelleStragiudiziali> = new EventEmitter<SezioneParcelleGiudiziali | SezioneParcelleStragiudiziali>();

  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService,
              protected modalNotifyService: ModalNotifyService) {
    super(operationService, campiForm, helpers, modalNotifyService);
  }

  ngOnInit() {
    this.setTitle('Ripartisci Parcella');
  }

  getRipartizioneNotula() {
    return (this.inserimento) ? new ParcellaSoggetto() : this.ripartizione;
  }

  getUrlReadSezioneControparti() {
    return this.urlReadSezioneControparti;
  }

  getUrlReadSezioneEconomica(){
    return this.urlReadSezioneEconomica;
  }

  getTotaleRipartizioni(parcella: ParcellaStragiudiziale, ripartizione: ParcellaSoggetto): number{
    let totale = 0;
    let newParcella = new ParcellaStragiudizialeAdapter(parcella).parcellaStragiudiziale;
    if(newParcella.parcelleSoggetti && newParcella.parcelleSoggetti.length>0){
      newParcella.parcelleSoggetti=newParcella.parcelleSoggetti.filter(el=>el.id!==ripartizione.id);
      newParcella.parcelleSoggetti.push(ripartizione);
    }
    else {
      newParcella.parcelleSoggetti = [];
      newParcella.parcelleSoggetti.push(ripartizione);
    }
    newParcella.parcelleSoggetti.forEach(element=>totale+=element.percentualeParcella);
    return totale;
  }

  getRequest(request: ParcellaSoggetto) {
    if(this.getTotaleRipartizioni(this.parcella, request)<=100){
      if(this.inserimento) {
        this.operationService.addRipartizioneParcella(this.urlUpdate, request, this.sezione.id, this.fascicolo.id).subscribe((response: any) => this.datiParcellaResponse(response));
      } else {
        this.operationService.updateRipartizioneParcella(this.urlUpdate, request, this.sezione.id).subscribe((response:any)=>this.datiParcellaResponse(response));
      }
    }
    else {
      this.modalNotifyService.customMessage('Percentuale massima di ripartizione raggiunta.');
    }
  }

  datiParcellaResponse(response: SezioneParcelleGiudizialiResponse | SezioneParcelleStragiudizialiResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(sezione: SezioneParcelleGiudiziali | SezioneParcelleStragiudiziali, parcella: ParcellaGiudiziale | ParcellaStragiudiziale, urlUpdate: string, fascicolo: FascicoloFull, inserimento: boolean, ripartizione?: ParcellaSoggetto, title?: string) {
    this.setTitle(title);
    this.parcella = parcella;
    this.fascicolo = fascicolo;
    this.sezione = sezione;
    this.urlUpdate = urlUpdate;
    // this.urlReadSezioneControparti = urlReadSezioneControparti;
    // this.urlReadSezioneEconomica = urlReadSezioneEconomica;
    // this.urlUpdatePetitumEconomico= urlUpdatePetitumEconomico;
    // if(idSezioneControparti) this.readSezioneControparti(idSezioneControparti);
    // if(idSezioneEconomica) this.readSezioneEconomica(idSezioneEconomica)
    this.inserimento=inserimento;
    if(!inserimento) this.ripartizione=ripartizione;
    this.createForm();
    this.populateSelect();
  }

}
